<template>
  <div class="today-alarm">
    <div class="middletitleleft dn-title-bg">
      <span>频率曲线</span>
    </div>
    <div class="bottomleft dn-content-bg" v-loading="ifLoad">
      <div
        v-resize="resize"
        :id="echartId"
        class="lineBox"
        ref="lineBoxOne"
      ></div>
    </div>
  </div>
</template>
<script>
let vm;
import uuidv1 from "uuid/v1";
export default {
  props: {
    frequency: {
      type: Object,
      default: () => () => ({}),
    },
    ifLoad: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echarts: null,
      echartId: uuidv1(),
    };
  },
  created() {},
  methods: {
    resize() {
      let vm = this;
      if (vm.echarts) {
        vm.echarts.resize();
      }
    },
    getLineEchart(obj) {
      let vm = this;
      if (vm.echarts == null){
        vm.echarts = vm.$echarts.init(document.getElementById(vm.echartId));
      } else {
        vm.echarts.clear();
      }
      var option = {
        legend: {
          height: "80%",
          left: "center",
          top: "5%",
          data: obj.title,
          textStyle: {
            color: "#666",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        color: ["#CCCC00"],
        xAxis: {
          type: "category",
          data: obj.xData,
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "Hz",
          scale: true /*按比例显示*/,
          axisLine: {
            lineStyle: {
              color: "#666",
            },
          },
        },
        series: obj.series,
      };
      vm.echarts.setOption(option, true);
      window.addEventListener("resize", function () {
        vm.echarts.resize();
      });
    },
  },
  watch: {
    frequency: {
      handler(newVal, oldVal) {
        let vm = this;
        console.log(newVal);
        vm.getLineEchart(newVal);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.today-alarm {
  display: flex;
  flex: 1;
  flex-flow: column;
}
.middletitleleft {
  //   background: #0197EE;
  color: #fff;
  font-weight: bold;
  display: flex;
  padding: 5px;
  font-size: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottomleft {
  flex: 1;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.lineBox {
  width: 100%;
  height: 100%;
}
</style>